export const ACTIVITY_FIELDS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.ActivityFieldsUpdated";
export const ACTIVITY_FIELDS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.ActivityFieldsInvalidated";
